import { completeDiameterRows } from "./pricing-diameters";
import { CustomerPricing, PriceList } from "./supplier-pricing-engine";

/** Validate effective prices: null customer values inherit; zero is an explicit rate. */
export function missingPricingFields(pl: PriceList, customer?: CustomerPricing, label: (key: string) => string = key => key): string[] {
  const custom = customer?.mode === "custom" ? customer : undefined;
  const missing: string[] = [];
  const valid = (value: number | null | undefined) => value != null && Number.isFinite(value) && value >= 0;
  completeDiameterRows(pl.diameterPrices, diameter => ({ diameter, ribbed: null, smooth: null, weldableExtra: null }), custom?.diameterOverrides.map(row => row.diameter)).forEach(row => {
    const override = custom?.diameterOverrides.find(value => value.diameter === row.diameter)?.pricePerTon;
    (["ribbed", "smooth"] as const).forEach(column => {
      if (!valid(override ?? row[column])) missing.push(`Ø ${row.diameter} · ${label(`diameter.${column}`)}`);
    });
  });
  ([["cutPerTon", "processing.cut"], ["bendPerTon", "processing.bend"], ["unitPrice", "processing.unitPrice"]] as const).forEach(([field, label]) => {
    if (!valid(custom?.[field] ?? pl[field])) missing.push(label);
  });
  if ((custom?.transportMode === "custom" || pl.transportMethod !== "none") && !valid(custom?.transportMode === "custom" ? custom.transportPrice : pl.transportPrice)) missing.push("transport.price");
  return missing;
}
